module.exports = __webpack_public_path__ + "static/media/thropy.93a72dc7.svg";